import { URLS } from '../../../constants';
import apiClient from '../../client';

const getAuthorizationAPI = {
  getAuthorization: ({ clientId }: { clientId: any }) =>
    apiClient.post(URLS.getAuthorizations, {
      data: {
        clientId,
      },
    }),
  deleteAuthorization: ({ id }: { id: any }) =>
    apiClient.post(URLS.deleteAuthorization, {
      data: {
        id,
      },
    }),
  getAuthorizationPatientNames: ({ parentUserId }: { parentUserId: any }) =>
    apiClient.post(URLS.userChild, {
      data: {
        parentUserId,
      },
    }),
  getAuthorizationPayors: ({ clientId }: { clientId: any }) =>
    apiClient.post(URLS.getPayors, {
      data: {
        clientId,
      },
    }),
  getAuthorizationById: ({ id }: { id: any }) =>
    apiClient.post(URLS.getAuthorizationById, {
      data: {
        id,
      },
    }),
  saveAuthorization: ({
    id,
    userChildId,
    documentName,
    description,
    validFrom,
    validTo,
    authorizations,
    file,
    userInsuranceId,
  }: {
    id: any;
    userChildId: any;
    documentName: any;
    description: any;
    validFrom: any;
    validTo: any;
    authorizations: any;
    file: any;
    userInsuranceId: any;
  }) =>
    apiClient.post(URLS.saveAuthorization, {
      data: {
        id,
        userChildId,
        documentName,
        description,
        validFrom,
        validTo,
        authorizations,
        file,
        userInsuranceId,
      },
    }),
  payorHistory: ({
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
    id,
  }: {
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
    id?: number;
  }) =>
    apiClient.post(URLS.organizationInsuranceHistory, {
      data: {
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'name',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'executedOn',
        },
        id,
      },
    }),
};
export default getAuthorizationAPI;
